export default "__VITE_ASSET__D8lTC8lr__"